export default __webpack_public_path__ + "img/vercor-left-with.15579abd.svg";